import React, { useState, useEffect, useRef } from 'react';
import { Input } from 'reactstrap';

const AuditLogFilter = ({ onFilterChange }) => {
    const [filters, setFilters] = useState({
        search: '',
        memory: '',
        responseTime: '',
        method: '',
        statusCode: '',
        startDate: '',
        endDate: ''
    });

    const isFirstRender = useRef(true);

    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        const handler = setTimeout(() => {
            if (onFilterChange) {
                onFilterChange(filters);
            }
        }, 500);

        return () => {
            clearTimeout(handler);
        };
    }, [filters, onFilterChange]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFilters(prev => ({ ...prev, [name]: value }));
    };

    const handleReset = () => {
        const resetFilters = {
            search: '',
            memory: '',
            responseTime: '',
            method: '',
            statusCode: '',
            startDate: '',
            endDate: ''
        };
        setFilters(resetFilters);
    };

    return (
        <div className="audit-filter-card">
            {/* First Row */}
            <div className="audit-filter-row">
                <div className="audit-filter-group">
                    <label>Method</label>
                    <select name="method" value={filters.method} onChange={handleChange} className="audit-filter-select">
                        <option value="">All Methods</option>
                        <option value="GET">GET</option>
                        <option value="POST">POST</option>
                        <option value="PUT">PUT</option>
                        <option value="DELETE">DELETE</option>
                    </select>
                </div>

                <div className="audit-filter-group">
                    <label>Status Code</label>
                    <select name="statusCode" value={filters.statusCode} onChange={handleChange} className="audit-filter-select">
                        <option value="">All Statuses</option>
                        <option value="2xx">2xx - Success</option>
                        <option value="3xx">3xx - Redirection</option>
                        <option value="4xx">4xx - Client Error</option>
                        <option value="5xx">5xx - Server Error</option>
                    </select>
                </div>

                <div className="audit-filter-group">
                    <label>Memory (Heap / RAM)</label>
                    <select name="memory" value={filters.memory} onChange={handleChange} className="audit-filter-select">
                        <option value="">All Usage</option>
                        <option value="low">Low (&lt; 1MB)</option>
                        <option value="medium">Medium (1MB - 5MB)</option>
                        <option value="high">High (&gt; 5MB)</option>
                    </select>
                </div>

                <div className="audit-filter-group">
                    <label>Response Time</label>
                    <select name="responseTime" value={filters.responseTime} onChange={handleChange} className="audit-filter-select">
                        <option value="">All Times</option>
                        <option value="fast">Fast (&lt; 100ms)</option>
                        <option value="moderate">Moderate (100ms - 500ms)</option>
                        <option value="slow">Slow (&gt; 500ms)</option>
                    </select>
                </div>
            </div>
            
            {/* Second Row */}
            <div className="audit-filter-row mt-3" style={{ alignItems: 'flex-end' }}>
                <div className="audit-filter-group" style={{ flex: '0 0 250px' }}>
                    <label>Search</label>
                    <Input 
                        type="text" 
                        name="search" 
                        value={filters.search} 
                        onChange={handleChange} 
                        className="pq-filter-input" 
                        placeholder="userId, path, feature" 
                    />
                </div>
               
                <div className="audit-filter-group" style={{ flex: '0 0 160px' }}>
                    <Input 
                        type={filters.startDate ? "date" : "text"}
                        name="startDate"
                        placeholder="Start Date"
                        value={filters.startDate}
                        max={filters.endDate || undefined}
                        onChange={handleChange}
                        onFocus={(e) => (e.target.type = "date")}
                        onBlur={(e) => (!e.target.value ? (e.target.type = "text") : null)}
                        className="pq-filter-input"
                    />
                </div>

                <div className="audit-filter-group" style={{ flex: '0 0 160px' }}>
                    <Input 
                        type={filters.endDate ? "date" : "text"}
                        name="endDate"
                        placeholder="End Date"
                        value={filters.endDate}
                        min={filters.startDate || undefined}
                        onChange={handleChange}
                        onFocus={(e) => (e.target.type = "date")}
                        onBlur={(e) => (!e.target.value ? (e.target.type = "text") : null)}
                        className="pq-filter-input"
                    />
                </div>

                {Object.values(filters).some(val => val !== '') && (
                    <div className="audit-filter-actions" style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                        <button onClick={handleReset} className="btn-audit-reset">Clear Filters</button>
                    </div>
                )}
            </div>           
        </div>
    );
};

export default AuditLogFilter;
